"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMoreButton = void 0;
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
exports.ShowMoreButton = (props) => {
    const { label, loading, color } = props, buttonProps = __rest(props, ["label", "loading", "color"]);
    return (react_1.default.createElement(material_1.Button, Object.assign({}, buttonProps, { disabled: loading, color: loading ? 'inherit' : color }), loading ? react_1.default.createElement(material_1.CircularProgress, { size: "1rem", color: "inherit" }) : label));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2hvd01vcmVCdXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TaG93TW9yZUJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7O0dBTUc7QUFDSCxrREFBMEI7QUFDMUIsNENBQXNFO0FBT3pELFFBQUEsY0FBYyxHQUFHLENBQUMsS0FBMkIsRUFBRSxFQUFFO0lBQzVELE1BQU0sRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssS0FBcUIsS0FBSyxFQUFyQixXQUFXLFVBQUssS0FBSyxFQUFqRCw2QkFBeUMsQ0FBUSxDQUFDO0lBQ3hELE9BQU8sQ0FDTCw4QkFBQyxpQkFBTSxvQkFBSyxXQUFXLElBQUUsUUFBUSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUssS0FDM0UsT0FBTyxDQUFDLENBQUMsQ0FBQyw4QkFBQywyQkFBZ0IsSUFBQyxJQUFJLEVBQUMsTUFBTSxFQUFDLEtBQUssRUFBQyxTQUFTLEdBQUcsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUM1RCxDQUNWLENBQUM7QUFDSixDQUFDLENBQUMifQ==